/*
 * Copyright (c) 2021
 * Company: G-Portal
 * Filename: utils.ts
 * Class: utils.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { MutationRequestState, MutationRequestStatus } from './types';

export const getDefaultState = <T, E>(): MutationRequestState<T, E> => ({
  error: undefined,
  data: undefined,
  status: undefined,
});

export const getDefaultLoadingState = <T, E>(): MutationRequestState<T, E> => ({
  ...getDefaultState(),
  status: MutationRequestStatus.LOADING,
});

export const getDefaultErrorState = <T, E>(): MutationRequestState<T, E> => ({
  ...getDefaultState(),
  status: MutationRequestStatus.ERROR,
});

export const isLoading = <T, E>(
  state: MutationRequestState<T, E>,
) : boolean => state.status === MutationRequestStatus.LOADING;

export const isSuccess = <T, E>(
  state: MutationRequestState<T, E>,
) : boolean => state.status === MutationRequestStatus.SUCCESS;

export const isFailure = <T, E>(
  state: MutationRequestState<T, E>,
) : boolean => state.status === MutationRequestStatus.ERROR;
